/**
 * Helper para tokenização de cartão de crédito usando Pagar.me v5
 * @param {Object} cardData - Dados do cartão
 * @param {string} cardData.holder_name - Nome do titular do cartão
 * @param {string} cardData.number - Número do cartão (sem espaços)
 * @param {string} cardData.exp_month - Mês de expiração (MM)
 * @param {string} cardData.exp_year - Ano de expiração (AA)
 * @param {string} cardData.cvv - Código de segurança (CVV)
 * @returns {Promise<Object>} Token do cartão retornado pela API
 * @throws {Error} Erro ao processar o cartão
 */
export const createCardTokenPagarmeV5 = async cardData => {
  const encryptionKey = process.env.REACT_APP_PAGARME_V5_ENCRYPTION_KEY;

  if (!encryptionKey) {
    throw new Error("Chave de criptografia não configurada");
  }

  const response = await fetch(
    `https://api.pagar.me/core/v5/tokens?appId=${encryptionKey}`,
    {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        type: "card",
        card: {
          holder_name: cardData.holder_name,
          number: cardData.number.replace(/\s/g, ""),
          exp_month: cardData.exp_month,
          exp_year: cardData.exp_year,
          cvv: cardData.cvv,
        },
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`Erro ao processar o cartão: ${response.status}`);
  }

  const data = await response.json();

  if (!data || !data.id) {
    throw new Error("Resposta inválida da API de tokenização");
  }

  return data;
};

